import { render, staticRenderFns } from "./ViewAddedExpensePage.vue?vue&type=template&id=b6f27bf0&scoped=true"
import script from "./ViewAddedExpensePage.vue?vue&type=script&lang=js"
export * from "./ViewAddedExpensePage.vue?vue&type=script&lang=js"
import style0 from "./ViewAddedExpensePage.vue?vue&type=style&index=0&id=b6f27bf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f27bf0",
  null
  
)

export default component.exports